import { Navigate, RouteObject } from 'react-router-dom';

export type AppRouteObject = RouteObject & {
  /**
   * Means route can be used as index route.
   * If multiple routes are defined as indexable, only first matching route will be used to build the index route
   */
  indexable?: boolean;
};

/**
 * Helper function to use in route definition,
 * multiple routes can be defined as `indexable: true`, but only first matching route will be used to build
 * the index route
 *
 * @param args array of routes or boolean values
 * @returns array of routes
 * @example
 * const routes = routes([
 *   isAdmin && { path: '/settings', index: true, element: <Settings /> },
 *   isUser && { path: '/profile', index: true, element: <Profile /> },
 * ]);
 */
export function routes(args: Array<AppRouteObject | boolean>): RouteObject[] {
  const routes = args.filter(Boolean) as AppRouteObject[];
  const hasIndexRoute = routes.some((route) => route.index);
  const indexableRoutes = routes.filter((route) => route.indexable);
  return !hasIndexRoute && indexableRoutes.length > 0
    ? [...routes, { index: true, element: <Navigate to={indexableRoutes[0].path!} replace /> }]
    : routes;
}
